import { StyleSheet } from 'react-native';
import color from 'color';
import styled from 'styled-components/native';

import { windowWidth } from '@src/configuration/constants';

const Component = styled.View<{
  vertical?: boolean;
  horizontalPadding?: number;
}>`
  width: ${({ vertical, horizontalPadding }) =>
    vertical
      ? `${StyleSheet.hairlineWidth}px`
      : horizontalPadding
      ? `${windowWidth - horizontalPadding}px`
      : '96%'};
  height: ${({ vertical }) =>
    vertical ? '96%' : `${StyleSheet.hairlineWidth}px`};
  background-color: #cbcbcb;
  align-self: center;
`;

Component.displayName = 'Divider';

export default Component;
